import React, { useState, useEffect } from "react";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/index.css";
import { Button, Grid } from "@material-ui/core";
import styled from "styled-components";
import { DeleteOutline } from "@material-ui/icons";
import PropTypes from "prop-types";
import CategoriesDialog from "./CategoriesDialog";
import SimpleConfirmDialog from "../../../waybee-ui/Dialog/SimpleConfirmDialog";

const DataGrid = styled(ReactDataGrid)`
  &.InovuaReactDataGrid {
    border: none;
    font-family: Nunito, sans-serif;
    font-size: 14px;
    min-height: 550px;
    cursor: pointer;
  }
  .InovuaReactDataGrid__column-header {
    border: none;
  }
`;

const NewCategoryButton = styled(Button)`
  margin: 20px 0;
`;

const TableContainer = styled(Grid)`
  padding: 20px 16px;
`;

const Categories = ({ categories, onDeleteCategory, onNewCategory }) => {
  const [dataSource, setDataSource] = useState(categories);
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    categoryId: null
  });
  const [pendingCategory, setPendingCategory] = useState(null);
  const [confirmCreateDialog, setConfirmCreateDialog] = useState(false);

  useEffect(() => {
    setDataSource(categories);
  }, [categories]);

  const handleDelete = categoryId => {
    setConfirmDialog({ open: true, categoryId });
  };

  const handleConfirmDelete = () => {
    if (confirmDialog.categoryId) {
      onDeleteCategory(confirmDialog.categoryId);
    }
    setConfirmDialog({ open: false, categoryId: null });
  };

  const handleCloseConfirm = () => {
    setConfirmDialog({ open: false, categoryId: null });
  };

  const onSave = values => {
    setPendingCategory(values);
    setConfirmCreateDialog(true);
  };

  const handleConfirmCreate = () => {
    if (pendingCategory) {
      onNewCategory(pendingCategory);
    }
    setPendingCategory(null);
    setConfirmCreateDialog(false);
    setOpenDialog(false);
  };

  const handleCloseCreateConfirm = () => {
    setPendingCategory(null);
    setConfirmCreateDialog(false);
  };

  const columns = [
    {
      name: "id",
      header: "ID",
      defaultFlex: 1,
      maxWidth: 100,
      resizable: false,
      render: ({ data }) => data.category?.id || ""
    },
    {
      name: "name",
      header: "Nome",
      minWidth: 50,
      defaultFlex: 1,
      resizable: false,
      render: ({ data }) => data.category?.name || ""
    },
    {
      name: "description",
      header: "Descrição",
      maxWidth: 1000,
      defaultFlex: 2,
      resizable: false,
      render: ({ data }) => data.category?.description || ""
    },
    {
      name: "action",
      header: "Ações",
      maxWidth: 100,
      defaultFlex: 1,
      editable: false,
      resizable: false,
      render: rowData => {
        const categoryId = rowData?.data?.category?.id;
        return (
          <Button
            id={rowData.rowIndex}
            style={{
              minWidth: 36,
              minHeight: 36,
              borderRadius: "50%",
              background: "#fff",
              transition: "background 0.2s",
              padding: 0
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = "#ffeaea";
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = "#fff";
            }}
            onClick={() => handleDelete(categoryId)}
          >
            <DeleteOutline style={{ color: "#e53935" }} />
          </Button>
        );
      }
    }
  ];

  return (
    <TableContainer>
      <NewCategoryButton
        variant="outlined"
        onClick={() => {
          setOpenDialog(true);
        }}
      >
        Adicionar Categoria
      </NewCategoryButton>
      <DataGrid
        showCellBorders={false}
        showZebraRows={false}
        resizable={false}
        reorderColumns={false}
        cellSelectionByIndex={false}
        sortable={false}
        idProperty="id"
        columns={columns}
        dataSource={dataSource}
        style={{ minHeight: 500 }}
        showColumnMenuTool={false}
      />
      <CategoriesDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSave={onSave}
      />
      <SimpleConfirmDialog
        open={confirmDialog.open}
        title="Deletar categoria"
        message="Ao confirmar, a categoria será deletada. Deseja continuar?"
        onConfirm={handleConfirmDelete}
        onClose={handleCloseConfirm}
      />
      <SimpleConfirmDialog
        open={confirmCreateDialog}
        title="Criar categoria"
        message="Atenção: Confirme os dados inseridos, após criar a categoria, não será possível editá-la, apenas deletar. Deseja continuar?"
        onConfirm={handleConfirmCreate}
        onClose={handleCloseCreateConfirm}
      />
    </TableContainer>
  );
};

Categories.propTypes = {
  onDeleteCategory: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onNewCategory: PropTypes.func.isRequired
};

export default Categories;
